import effectManager from '../module/effect';
import Param from '../param';
let effect;
const param = new Param();
let pageID = document.body.id;

export default class madeinjapanManager {
    constructor() {

        effect = new effectManager();

        // kv
        this.kv = document.getElementById('p-kv');
        this.kvCopy = document.getElementById('p-kv-copy');
        this.kvCopyFirst = document.querySelectorAll("#p-kv-copy .en .first");
        this.kvCopyLast = document.querySelectorAll("#p-kv-copy .en .last");
        this.kvCopyBlack = document.querySelector("#p-kv-copy .black");
        this.kvCopyWhite = document.querySelector("#p-kv-copy .white");
        this.kvLine = document.querySelector("#p-kv-copy .line");
        this.kvText = document.querySelector("#p-kv-copy .jp");
        this.kvPhoto = document.getElementById("p-kv-photo-object");
        this.kvPhotoFade = document.querySelector("#p-kv-photo.fade");
        this.kvCover = document.querySelector("#p-kv-photo .cover");
        this.kvNumber = document.getElementById("p-kv-item");
        this.imageObject = document.querySelectorAll('.image__object');

        if(param.userAgent === "pc" && param.browserType !== 'IE'&& pageID === "made_in_japan"){
            TweenMax.set(this.kvPhotoFade,{scale:1.08})
        }
        if(param.userAgent === "pc" && pageID === "made_in_japan"){
            TweenMax.set([this.kvCopyWhite,this.kvCopyBlack],{opacity:0});
            TweenMax.set(this.kvPhotoFade,{opacity:0});
            TweenMax.set([this.kvLine,this.kvText],{ x:50,opacity:0 });
        }
        if (param.userAgent === "pc"
            && (pageID === "made_in_japan01"
                || pageID === "made_in_japan02"
                || pageID === "made_in_japan03"
                || pageID === "made_in_japan04"
                || pageID === "made_in_japan05")) {
            if(param.browserType !== 'IE') {
                TweenMax.set(this.kvPhoto, {scale: 1.08});
            }
            TweenMax.set(this.kvPhoto, {opacity: 0});
            TweenMax.set([this.kvCopyWhite,this.kvCopyBlack],{opacity:0});
            TweenMax.set(this.kvCopyFirst,{ x:100,opacity:0 });
            TweenMax.set(this.kvCopyLast,{ x:-100,opacity:0 });
            TweenMax.set([this.kvLine,this.kvText],{ x:50,opacity:0 });
            TweenMax.set(this.kvNumber,{x:-40});
        }

        this.anime = '';
    }
    init(){
        if(param.userAgent === "pc"){
            for(let i=0; i<this.imageObject.length; i++){
                this.imageObject[i].addEventListener('mousemove',()=>{
                    TweenMax.to(this.imageObject[i],3,{
                        opacity:0.6,
                        ease: "Power2.easeOut"
                    });
                });
                this.imageObject[i].addEventListener('mouseout',()=>{
                    TweenMax.to(this.imageObject[i],3,{
                        opacity:1,
                        ease: "Power2.easeOut"
                    });
                });
            }
        }
    }

    splash(){
        if(pageID === "made_in_japan" && param.userAgent === "pc"){
            if(param.browserType !== 'IE'){
                TweenMax.to(this.kvPhotoFade,14,{
                    delay:0.3,
                    scale:1,
                    ease: "Power2.easeOut",
                    className: "+=is-will",
                    onComplete:()=> {
                        TweenMax.set(this.kvPhotoFade,{
                            className: "-=is-will"
                        });
                    }
                });
            }

            TweenMax.set(this.kvCopy, { delay:0.6,className:"+=is-done"});
            TweenMax.to(this.kvPhotoFade,4.0,{
                delay:1,
                opacity:1,
                ease: "Expo.easeOut",
            });
            TweenMax.to(this.kvCopyBlack,2.0,{
                opacity:1,
                ease: "Power1.easeOut",
            });
            TweenMax.to(this.kvCopyBlack,4.0,{
                delay:1,
                opacity:0,
                ease: "Expo.easeOut",
            });
            TweenMax.to(this.kvCopyWhite,4.0,{
                delay:1,
                opacity:1,
                ease: "Expo.easeOut"
            });
            TweenMax.to(this.kvText,1.5,{
                delay:0.7,
                x:0,
                opacity:1,
                ease: "Expo.easeOut",
            });
        }

        if (param.userAgent === "pc"
            && (pageID === "made_in_japan01"
                || pageID === "made_in_japan02"
                || pageID === "made_in_japan03"
                || pageID === "made_in_japan04"
                || pageID === "made_in_japan05")) {
            if(param.browserType !== 'IE'){
                TweenMax.to(this.kvPhoto,3.2,{
                    opacity:1,
                    ease: "Power2.easeOut"
                });
                this.kvPhoto.classList.add('is-will');
                this.anime = TweenMax.to(this.kvPhoto,14,{
                    delay:0.3,
                    scale:1,
                    ease: "Power2.easeOut",
                    onComplete:()=> {
                        this.kvPhoto.classList.remove('is-will');
                    }
                });
            }else{
                TweenMax.to(this.kvPhoto,3.2,{
                    opacity:1,
                    ease: "Power2.easeOut"
                });
            }

            for(let i=0; i<this.kvCopyFirst.length; i++){
                TweenMax.to([this.kvCopyFirst[i],this.kvCopyLast[i]],.7,{
                    delay:0.3,
                    opacity:1,
                    ease: "Expo.easeOut",
                });
                TweenMax.to([this.kvCopyFirst[i],this.kvCopyLast[i]],1.5,{
                    delay:0.3,
                    x:0,
                    ease: "Expo.easeOut",
                    onComplete:()=>{
                        TweenMax.to(this.kvNumber,1.5,{
                            x:0,
                            ease: "Expo.easeOut"
                        });
                    }
                });
            }

            TweenMax.staggerTo([this.kvLine,this.kvText],1.5,{
                delay:0.7,
                x:0,
                opacity:1,
                ease: "Expo.easeOut",
            },0.2);

            TweenMax.set(this.kvCopy, { delay:0.6,className:"+=is-done"});



            // TweenMax.to(this.kvCopyBlack,2.0,{
            //     opacity:1,
            //     ease: "Power1.easeOut",
            //     onComplete:function(){
            //         TweenMax.to(this.kvNumber,1.5,{
            //             x:0,
            //             ease: "Expo.easeOut",
            //         });
            //     }
            // });
        }
    }

    render(_y,_h){

        if(_y > _h){
            if(this.anime === '') return;
            this.anime.pause(14);
        }

    }
    resize(_w,_h,_display){


    }


}